import { render, staticRenderFns } from "./photo-swipe.vue?vue&type=template&id=24db3d88&scoped=true&"
import script from "./photo-swipe.vue?vue&type=script&lang=js&"
export * from "./photo-swipe.vue?vue&type=script&lang=js&"
import style0 from "./photo-swipe.scss?vue&type=style&index=0&id=24db3d88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db3d88",
  null
  
)

export default component.exports